import { useState, useEffect, type CSSProperties } from 'react'

export function useKeyboardShift(cardRef: React.RefObject<HTMLElement | null>): CSSProperties {
  const [offset, setOffset] = useState(0)
  useEffect(() => {
    const vv = window.visualViewport
    if (!vv) return
    const onResize = () => {
      const keyboardHeight = window.innerHeight - vv.height
      if (keyboardHeight <= 100 || !cardRef.current) { setOffset(0); return }
      const cardRect = cardRef.current.getBoundingClientRect()
      const visibleBottom = vv.height + (vv.offsetTop || 0)
      const overlap = cardRect.bottom - visibleBottom
      setOffset(overlap > 0 ? Math.min(overlap + 16, keyboardHeight * 0.5) : 0)
    }
    vv.addEventListener('resize', onResize)
    return () => vv.removeEventListener('resize', onResize)
  }, [cardRef])
  return offset > 0
    ? { transform: `translateY(-${offset}px)`, transition: 'transform 0.25s ease-out' }
    : { transition: 'transform 0.25s ease-out' }
}
